const ProgressBar = ({ currentStep, completedSteps, setCurrentStep }) => {
  const steps = [1, 2, 3, 4, 5, 6, 7, 8];

  const handleStepButton = (step) => {
    setCurrentStep(step);
  };

  return (
    <div className="flex justify-center py-2 md:py-5">
      {steps.map((step, index) => {
        const isCurrent = currentStep === step;
        const isCompleted = completedSteps.includes(step);
        let bgColor = "bg-dBlue-100 text-black"; // default
        let lineColor = "bg-dBlue-100"; // default

        if (isCompleted) {
          bgColor = "bg-green-3 text-white";
          lineColor = "bg-green-3";
        }

        if (isCurrent) {
          bgColor = "bg-dark-blue text-white";
          lineColor = "bg-dark-blue";
        }

        return (
          <div
            className="flex items-center"
            onClick={() => handleStepButton(step)}
          >
            <div
              key={step}
              className={`py-1 px-2 sm:px-3 text-sm sm:text-lg rounded-md transition-all duration-200 ${bgColor} relative cursor-pointer`}
              onClick={() => handleStepButton(step)}
            >
              <p>{step}</p>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`h-1 w-5 sm:w-12 transition-all duration-200 ${lineColor}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
